import React from 'react';
import { useCountry } from '@increasecard/increase-core';
export var CountryFilter = function (_a) {
    var children = _a.children, hideFor = _a.hideFor;
    var country = useCountry();
    if (hideFor && hideFor.includes(country)) {
        return null;
    }
    return React.createElement(React.Fragment, null, children);
};
